import styled from "styled-components";

export const HeadingLarge = styled.h1`
  font-family: Manrope;
  font-size: 32px;
  font-weight: 600;
  color: #000000;
  line-height: 40px; /* 125% */
  letter-spacing: -0.256px;
`;

export const Texts = styled.p`
  font-family: Manrope;
  font-size: 18px;
  color: #0d0d0d;
  font-weight: 600;
`;

export const LabelMedium = styled.p`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 600;
  color: #0d0d0d;
  line-height: 24px;
  margin: 0;
`;

export const BodyShortMedium = styled.p`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  margin: 0;
`;

export const BodyShortMediumStrong = styled.p`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  line-height: 24px;
  margin: 0;
`;

export const BodyShortLargeStrong = styled.p`
  font-family: Manrope;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.02px;
  margin: 0;
`;

export const SmallLink = styled.p`
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.032px;
  margin: 0;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
`;

export const MediumLinkStrong = styled.p`
  font-family: Manrope;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #0d0d0d;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const IngressDefault = styled.p`
  font-family: Manrope;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #0d0d0d;
  letter-spacing: -0.02px;
  margin: 0;
`;
